import { Breadcrumb, Card } from "antd";
import React from "react";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../../assests/images/quicktbreadrans.svg";
import AccountCard from "../../../components/account-card";
import { ReactComponent as InternalIcon } from "../../../assests/images/manageBenfeciary.svg";
import { ReactComponent as OtherIcon } from "../../../assests/icons/Other.svg";
import { ReactComponent as InternationalIcon } from "../../../assests/images/internationaltrans.svg";
import { ReactComponent as WalletIcon } from "../../../assests/images/payments.svg";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";
import { useTranslation } from "react-i18next";
import FEATURE_CONFIG from "client/feature.config.json";
import { useSelector } from "react-redux";
import { transferAccountListSelector } from "../../../store/selectors/app.selector";

export default function QuickPayment() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const accountList = useSelector(transferAccountListSelector);

  return (
    <>
      <Breadcrumb separator=">" className="hide-xs">
        {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/transfer")}>
            {t("navigation.transfer", {
              defaultValue: "Transfers",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("pages.sendMoney.payee.quick_transfer", {
              defaultValue: "Quick Transfer",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.sendMoney.payee.quick_transfer", {
                defaultValue: "Quick Transfer",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card">
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card ">
            <div className="row">
              {accountList?.length > 1 && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/own-quick-transfer")}
                  >
                    <div className="my-3">
                      <InternalIcon alt="new" height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.own_transfer", {
                          defaultValue: "Own Transfer",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.", {
                          defaultValue: "Make Quick Own Transfer",
                        })}
                      </span>
                    </div>
                  </Card>
                </div>
              )}
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                {FEATURE_CONFIG.ADD.INTERNAL_BENE && (
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/internal-quick-transfer")}
                  >
                    <div className="my-3">
                      <InternalIcon alt="new" height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.internal_transfer", {
                          defaultValue: "Internal Transfer",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.make_quick_internal", {
                          defaultValue: "Make Quick Internal Transfer",
                        })}
                      </span>
                    </div>
                  </Card>
                )}
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                {FEATURE_CONFIG.ADD.DOMESTIC_BENE && (
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/other-quick-transfer")}
                  >
                    <div className="my-3">
                      <OtherIcon alt="new" height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.domestic_transfer", {
                          defaultValue: "Domestic Transfer",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.make_quick_domestic", {
                          defaultValue: "Make Quick Domestic Transfer",
                        })}
                      </span>
                    </div>
                  </Card>
                )}
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                {FEATURE_CONFIG.ADD.INTERNATIONAL_BENE && (
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/international-quick-transfer")}
                  >
                    <div className="my-3">
                      <InternationalIcon alt="new" height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.international_transfer", {
                          defaultValue: "International Transfer",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.make_quick_international", {
                          defaultValue: "Make Quick International Transfer",
                        })}
                      </span>
                    </div>
                  </Card>
                )}
              </div>
              {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/wallet-quick-transfer")}
                >
                  <div className="my-3">
                    <WalletIcon alt="new" height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.Add_Bene.wallet", {
                        defaultValue: "Wallet",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.sendMoney.payee.make_quick_wallet", {
                        defaultValue: "Make Quick Wallet Transfer",
                      })}
                    </span>
                  </div>
                </Card>
              </div> */}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
